import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
  light?: boolean;
};
export function Countdown({
  className = '',
  light = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(82536);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['seg', seconds % 60]];
  return <div className={`inline-flex items-start gap-2 rounded-xl border px-4 py-2 font-mono font-black ${light ? 'border-gold/50 bg-petrolDark text-onDark' : 'border-line bg-white text-petrol'} ${className}`} aria-label="Tiempo restante de la oferta" data-id="element-286" data-mp="1xfs30k0p6rmm">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-287" data-mp="34u4zl3n971e6" data-mpi={index}>
          {index > 0 && <span className="pt-1 text-xl opacity-40" data-id="element-288" data-mp="34tbzglisva50">:</span>}
          <span className="flex min-w-[36px] flex-col items-center leading-none" data-id="element-289" data-mp="2c8ggajz0vm5y">
            <b className="text-xl" data-id="element-290" data-mp="2h68kaccxyyqi">{String(value).padStart(2, '0')}</b>
            <small className="mt-1 font-sans text-[9px] font-bold uppercase tracking-wider opacity-70" data-id="element-291" data-mp="2h8kzihrbeuzv">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}